import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'any' })
export class AvanoFormService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  // Will be used within directives (e.g. input / textarea) and can
  // be used within components (combobox) to generate a label and automatically
  // get the correct styling applied!
  generateFormLabelElement(): HTMLLabelElement {
    const labelElement = this.renderer.createElement('label');
    this.renderer.addClass(labelElement, 'avano-formlabel');
    return labelElement;
  }

  generateRequiredElement(): HTMLElement {
    const requiredElement = this.renderer.createElement('i');
    this.renderer.addClass(requiredElement, 'icon-special-required-indicator');
    return requiredElement;
  }

  generateTooltipElement(tooltip: string): HTMLElement {
    const requiredElement = this.renderer.createElement('i');
    this.renderer.addClass(requiredElement, 'icon-content-info');
    this.renderer.addClass(requiredElement, 'avano-tooltip-icon');
    requiredElement.setAttribute('title', tooltip);
    return requiredElement;
  }
}
